import { render, staticRenderFns } from "./Tuition.vue?vue&type=template&id=2bb5454e&scoped=true&"
import script from "./Tuition.vue?vue&type=script&lang=ts&"
export * from "./Tuition.vue?vue&type=script&lang=ts&"
import style0 from "./Tuition.vue?vue&type=style&index=0&id=2bb5454e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb5454e",
  null
  
)

export default component.exports